<h2>Upgrade Gitlab Version</h2>

<label>
  New Version
  <input type="text" [(ngModel)]="newVersion">
</label>

<button class="btn btn-primary btn-sm" (click)="upgrade()">Upgrade</button>
<button class="btn btn-secondary btn-sm" (click)="devToDeployDev()">dev -> deploy_dev</button>
<a class="btn btn-secondary btn-sm" target="_blank" rel="noopener" [href]="'https://git.stranner.org/uni/reset2-e2e/-/pipelines'">e2e</a>

@if (status) {
  <div>
    <p>
      <a [href]="status.backendUrl" target="_blank" rel="noopener">Backend MR</a>
    </p>
    <p>
      <a [href]="status.dockerUrl" target="_blank" rel="noopener">Docker MR</a>
    </p>
    <table class="table table-hover">
      <thead>
        <th></th>
        <th>Backend</th>
        <th>Docker</th>
      </thead>
      <tbody>
        <tr>
          <td>ExitCode</td>
          <td>{{status.backendCmd.exitCode}}</td>
          <td>{{status.dockerCmd.exitCode}}</td>
        </tr>
        <tr>
          <td>TerminatedOnItsOwn</td>
          <td>{{status.backendCmd.terminatedOnItsOwn}}</td>
          <td>{{status.dockerCmd.terminatedOnItsOwn}}</td>
        </tr>
        <tr>
          <td>stdout</td>
          <td><pre>{{status.backendCmd.stdout}}</pre></td>
          <td><pre>{{status.dockerCmd.stdout}}</pre></td>
        </tr>
        <tr>
          <td>stderr</td>
          <td><pre>{{status.backendCmd.stderr}}</pre></td>
          <td><pre>{{status.dockerCmd.stderr}}</pre></td>
        </tr>
      </tbody>
    </table>
  </div>
}

<hr>

  @if (devDeployDevStatus) {
    <div>
      <table class="table table-hover">
        <thead>
          <th></th>
          <th>Docker</th>
          <th>Backend</th>
          <th>Frontend</th>
        </thead>
        <tbody>
          <tr>
            <td>ExitCode</td>
            <td>{{devDeployDevStatus.docker.exitCode}}</td>
            <td>{{devDeployDevStatus.backend.exitCode}}</td>
            <td>{{devDeployDevStatus.frontend.exitCode}}</td>
          </tr>
          <tr>
            <td>TerminatedOnItsOwn</td>
            <td>{{devDeployDevStatus.docker.terminatedOnItsOwn}}</td>
            <td>{{devDeployDevStatus.backend.terminatedOnItsOwn}}</td>
            <td>{{devDeployDevStatus.frontend.terminatedOnItsOwn}}</td>
          </tr>
          <tr>
            <td>stdout</td>
            <td><pre>{{devDeployDevStatus.docker.stdout}}</pre></td>
            <td><pre>{{devDeployDevStatus.backend.stdout}}</pre></td>
            <td><pre>{{devDeployDevStatus.frontend.stdout}}</pre></td>
          </tr>
          <tr>
            <td>stderr</td>
            <td><pre>{{devDeployDevStatus.docker.stderr}}</pre></td>
            <td><pre>{{devDeployDevStatus.backend.stderr}}</pre></td>
            <td><pre>{{devDeployDevStatus.frontend.stderr}}</pre></td>
          </tr>
        </tbody>
      </table>
    </div>
  }

  <hr>

    <div class="row">
      @for (deploymentType of deploymentTypes; track deploymentType) {
        <div class="col-4">
          <h3><a target="_blank" rel="noopener" [href]="'https://git.stranner.org/uni/reset2-' + (deploymentType.toLowerCase()) + '/-/pipelines'">Deployables {{deploymentType}}</a></h3>
          <table class="table table-hover">
            <thead>
              <th>id</th>
              <th>date</th>
              <th>deployments</th>
              <th>actions</th>
            </thead>
            <tbody>
              @for (deployable of deployablesPerType[deploymentType]; track deployable.id) {
                <tr>
                  <td>{{deployable.id}}</td>
                  <td>{{deployable.date}} <br> {{gitCommitHashToNames[deployable.gitCommitHash]}}</td>
                  <td>
                    @for (deployment of deployable.deployments; track deployment) {
                      <span>
                        {{deployment.stage}} {{deployment.endTime}} - {{isSuccess(deployment)}}{{deployment.commands.length}}<br>
                      </span>
                    }
                  </td>
                  <td>
                    <button class="btn btn-primary btn-sm" (click)="deploy('test', deployable)">Deploy DEV</button>
                    <button class="btn btn-primary btn-sm" (click)="deploy('prod', deployable)">Deploy PROD</button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
